export { default } from './CurrencyPrice'
